import useUpdateContact from "queryHooks/useUpdateContact/useUpdateContact";

const useUpdateContactForm = ({ customerId, contactId }) => {
  return useUpdateContact(customerId, contactId);
};

export default useUpdateContactForm;
